const VOID_ELIGIBLE_UNDERLYING_STATUSES = new Set(["doa", "in_warranty"]);
const JAKARTA_DATE_FORMAT = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Asia/Jakarta",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

export function serviceOperationalDateFromTimestamp(value) {
  if (!value) return null;
  const text = value instanceof Date ? "" : String(value);
  const timestamp = text && !/(?:Z|[+-]\d{2}:?\d{2})$/i.test(text) ? `${text}Z` : value;
  const instant = value instanceof Date ? value : new Date(timestamp);
  if (Number.isNaN(instant.getTime())) return null;
  const parts = Object.fromEntries(
    JAKARTA_DATE_FORMAT.formatToParts(instant).map((part) => [part.type, part.value])
  );
  return new Date(Number(parts.year), Number(parts.month) - 1, Number(parts.day));
}

export function isVoidWarrantyEligible(underlyingStatus) {
  return VOID_ELIGIBLE_UNDERLYING_STATUSES.has(underlyingStatus);
}

export function deriveVoidWarrantyControlState({
  authorized = true,
  busy = false,
  checked,
  currentStatus,
  underlyingStatus,
}) {
  const canTurnOffCurrentVoid = currentStatus === "void" && checked;
  return {
    disabled: !authorized || busy || (!canTurnOffCurrentVoid && !isVoidWarrantyEligible(underlyingStatus)),
    displayedStatus: checked ? "void" : (underlyingStatus || currentStatus),
    canReplaceReason: isVoidWarrantyEligible(underlyingStatus),
  };
}
